import { Component, EventEmitter, Output } from '@angular/core';
import { BaseGridComponent } from '@m4u-angular/base/component/BaseGridComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState, Log } from '@m4u-angular/base/entities/BaseEntities';
import { EnumLogLevel } from '@m4u-angular/core/framework/sysenums.enum';

class State extends BaseState {
    SelectedIDs: number[];
}
@Component({
    providers: ServiceBagServices,
    selector: 'app-log-grid',
    templateUrl: './log-grid.component.html',
    styleUrls: ['./log-grid.component.scss']
})
export class LogGridComponent extends BaseGridComponent<Log ,State> {

    @Output() selectItem: EventEmitter<Log> = new EventEmitter<Log>();

    constructor(A: ServiceBagService) {
        super(A, 'LogGridComponent', Log, State);
    }

    public onRowClicked(e) {
        this.selectItem.emit(e.data);
        if (e.data) {
            this.State.SelectedIDs = [e.data.EntryID];
        }
    }

    public getStatusColor(log: Log) {
        switch(log.Level) {
            case EnumLogLevel.Error:
                return 'cinnabar';
            case EnumLogLevel.Warning:
                return 'mango';
            case EnumLogLevel.Info:
                return 'portage';
        }
    }

}
